import { createFileRoute, redirect } from '@tanstack/react-router';
import { LoginPage } from '@/pages/LoginPage';
import { firebaseAuth } from '@/lib/firebase';

export const Route = createFileRoute('/login')({
  beforeLoad: async () => {
    // Already logged in → go to dashboard
    await firebaseAuth.authStateReady();
    if (firebaseAuth.currentUser) throw redirect({ to: '/dashboard' });
  },
  component: LoginPage,
});
